import { c as _c } from "react/compiler-runtime";
import { dateToIso8601, isValidDate } from '@onefootprint/core';
import type { Locale } from '@onefootprint/request-types';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { dateMaskForPattern, resolveBrowserDatePattern, toDateFormatPattern } from './date-mask';
import FormInput, { type FormInputProps } from './form-input';
import useDateExampleHint from './use-date-example-hint';
export type FormDateProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  // An explicitly configured SDK locale sets the mask; otherwise it follows the browser locale.
  locale?: Locale;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'inputMode' | 'placeholder'>;
export default function FormDate(t0) {
  const $ = _c(21);
  let hint;
  let locale;
  let props;
  let rules;
  if ($[0] !== t0) {
    ({
      rules,
      locale,
      hint,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = hint;
    $[2] = locale;
    $[3] = props;
    $[4] = rules;
  } else {
    hint = $[1];
    locale = $[2];
    props = $[3];
    rules = $[4];
  }
  const {
    t
  } = useTranslation("ui");
  let t1;
  if ($[5] !== locale) {
    t1 = toDateFormatPattern(locale) ?? resolveBrowserDatePattern();
    $[5] = locale;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const pattern = t1;
  const mask = dateMaskForPattern[pattern];
  const exampleHint = useDateExampleHint(pattern);
  let t2;
  if ($[7] !== pattern) {
    t2 = value => {
      if (!value) {
        return value;
      }
      return dateToIso8601(value, pattern) ?? value;
    };
    $[7] = pattern;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== pattern || $[10] !== t) {
    t3 = value_0 => {
      if (!value_0) {
        return true;
      }
      if (!isValidDate(value_0, pattern)) {
        return t(_temp);
      }
      return true;
    };
    $[9] = pattern;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== rules || $[13] !== t2 || $[14] !== t3) {
    t4 = {
      setValueAs: t2,
      validate: t3,
      ...rules
    };
    $[12] = rules;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const dateRules = t4;
  const t5 = hint ?? exampleHint;
  let t6;
  if ($[16] !== dateRules || $[17] !== mask || $[18] !== props || $[19] !== t5) {
    t6 = <FormInput {...props} hint={t5} rules={dateRules} inputMode="numeric" mask={mask} placeholder={mask.placeholder} />;
    $[16] = dateRules;
    $[17] = mask;
    $[18] = props;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function _temp($) {
  return $.components.form.date.errors.invalid;
}